import { Partial } from '@40seas/entities/common';
import { RutterJob } from './rutter-job.entity';

export class UpdateRutterJobDto extends Partial(RutterJob) {}
